/**
 * created by li si yi
 * 素材中心稿件待办处理
 */
import React, {Component} from 'react';
import {connect} from "react-redux";
import BaseComponent from "../../../../../base/BaseComponent";

class LikeWebsite extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    data = {};

    isSupport(data) {
        this.data = data;
        if (this.data
            && this.data.data
            && this.data.data.id
            && (this.data.activitiCategoryKey === "likewebsite"
                || this.data.activitiCategoryKey === "yggj"
                || this.data.activitiCategoryKey === "rwgj")) {
            return true;
        }
        return false;
    };

    getIcon = (data) => {
        let icon = 'ContributeIcon';
        if (data.activitiCategoryKey === "yggj") {
            icon = 'YGManuscript'
        } else if (data.activitiCategoryKey === "rwgj") {
            icon = 'CFManuscript'
        }
        return icon
    };
    handle = (data, call) => {
        let materialCenterStoryEditorConfig = this.sysConfigGetValueByKey("editor.config.materialCenterStory", "");
        try {
            materialCenterStoryEditorConfig = JSON.parse(materialCenterStoryEditorConfig);
        } catch (e) {
            console.log(e.toString())
        }
        window.openEditById({
            configName: data.data.openEditorStyle ? data.data.openEditorStyle : (materialCenterStoryEditorConfig?.configName ? materialCenterStoryEditorConfig?.configName : "materialCenterStoryEditor"),
            id: data.data.id
        });
        this.createPostMessage((e) => {
            let message = e['data'] ? JSON.parse(e['data'])['message'] : null;
            if (message == "请求刷新父页面") {
                call && call();
            }
        }, "ManuscriptsSubmitted")
    };

    render() {
        return (
            <div style={{display: 'none'}}>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(LikeWebsite)